export default {
    methods: {
        getIdCategoriaFormatada(id) {
            if (id) return id;
            return 'produtossemcategoria';
        }
    }
}